import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Button } from 'semantic-ui-react';
import { CreateResource, CreateTagGroup, ResourceSearch, TagSearch, TagView, FilteredResourceTable } from '../containers/index';
import './styles/App.css';

const propTypes = {
  view: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
};

const createButton = (view) => {
  if (view === 'resources') return (<CreateResource content="Resource" />);
  return (<CreateTagGroup content="Tag Group" />);
};

const search = (view) => {
  if (view === 'resources') return (<ResourceSearch />);
  return (<TagSearch />);
};

const changeViewButton = (view, setView) => {
  if (view === 'resources') {
    return (
      <Button
        content={'Edit Tags'}
        icon="edit"
        labelPosition="right"
        floated="right"
        onClick={() => {
          setView('tags');
        }}
      />
    );
  }
  return (
    <Button
      content={'Edit Resources'}
      icon="edit"
      labelPosition="right"
      floated="right"
      onClick={() => {
        setView('resources');
      }}
    />
  );
};

const activeView = (view) => {
  if (view === 'resources') {
    return <FilteredResourceTable />;
  }
  return (<TagView />);
};

const App = ({ view, setView }) => (
  <div className="appContainer">
    <Menu id="mainNav" fixed="top">
      <div id="left">{createButton(view)}</div>
      {search(view)}
      <div id="right">{changeViewButton(view, setView)}</div>
    </Menu>
    {activeView(view)}
  </div>
);

App.propTypes = propTypes;

export default App;



// WEBPACK FOOTER //
// ./src/components/BackendApp.jsx